import { render, staticRenderFns } from "./OfferCtaWithDeliveryPopin.vue?vue&type=template&id=1573b27c"
import script from "./OfferCtaWithDeliveryPopin.vue?vue&type=script&lang=js"
export * from "./OfferCtaWithDeliveryPopin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports